module.exports = __webpack_public_path__ + "static/media/pickle-bg.eb50fca1.png";